import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticateService } from '../services/authenticate.service';

@Directive({
  selector: '[appSignoutBeforeUnload]'
})
export class SignoutBeforeUnloadDirective {

  constructor(private router: Router, private authService: AuthenticateService) { }


  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    const href = this.router.url || '';
    console.log(this.router.url);
    if (href !== '/' && href.indexOf('login') === -1) {
      event.preventDefault();
      event.returnValue = false; // the browser will popup a question are you sure you want to leave?
      this.signOff();
    }
  }

  signOff(){
    this.authService.logout().subscribe(result => {
      // if here the browser tab was closed.
    });
  }


}
